

//use in routing through url
export { default as App } from './App/App';
export { default as SignIn } from './SignIn/SignIn';
export { default as SignUp } from './SignUp/SignUp';
export { default as ResetPwd } from './ResetPwd/ResetPwd';
export { default as ForgotPwd } from './ForgotPwd/ForgotPwd';
export { default as Dashboard } from './Dashboard/Dashboard';
export { default as Widget } from './Widget/Widget';
export { default as Integration } from './Integration/Integration';
export { default as Review } from './Review/Review';
export { default as Post } from './Post/Post';
export { default as Profile } from './Profile/Profile';
export { default as Pixel } from './Pixel/pixel';
export { default as Visitor } from './Visitor/Visitor';
// export { default as Plan } from './Plan/Plan';
export { default as Payment } from './Payment/Payment';
//export { default as Widgetshopify } from './Widgetshopify/Widgetshopify';


// WEBPACK FOOTER //
// ./src/containers/index.js